export const URL =
    "https://3r20mehvld.execute-api.ap-southeast-2.amazonaws.com"; // backend server URL
export const origin = "http://localhost:3000"; // origin url - to match backend server allowed origin list.
